import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private _appError$ = new BehaviorSubject<boolean>(false);

  public get appError$(): Observable<boolean> {
    return this._appError$.asObservable();
  }

  /**
   * Set a general App error, when the app becomes unuseable due to an error
   * @param value
   */
  public setAppError(value: boolean): void {
    this._appError$.next(value);
  }
}
